import { createReducer } from "@reduxjs/toolkit";
import { SET_IS_OLD_APP_VERSION } from "./version-actions";

const initialState = false;

const version = createReducer(initialState, {
  [SET_IS_OLD_APP_VERSION]: (_, { payload }) => payload,
});

export default version;
